/**************************************************
 * Nombre:       Tarjeta_Deposito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useObtenerAncho} from "../../Modulo_Graficas/Hooks/useObtenerAncho";
import {useEffect, useRef, useState} from "react";
import Dona_Limpia from "../../Modulo_Graficas/Graficas/Dona_Limpia";
import {theme} from "../../Tema";
import {reducirHash} from "../../CodigoCliente/Funciones/reducirHash";
import {formatoMonedaTabla} from "../../Modulo_Tabla_2025/Utilidades/formatoMonedaTabla";
import RelojProcesando from "../Secciones/Componentes/RelojProcesando";
import RelojActivo from "../Secciones/Componentes/RelojActivo";
import {obtenerFechaRendimientos} from "../../CodigoCliente/Funciones/obtenerFechaRendimientos";
import {obtenerPorcentaje} from "../../CodigoCliente/Funciones/obtenerPorcentaje";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {obtenerRendimientosBonosContrato} from "../../CodigoCliente/Contratos/obtenerRendimientosBonosContrato";


const Tarjeta_Contratos = ({item}) => {
    const refe = useRef()
    const {sCell} = useResponsive()
    const {ancho} = useObtenerAncho({contenedor: refe})
    const [rendimientosBonos, setRendimientosBonos] = useState(0)


    const obtenerEstado = () => {

        if (item.fechaInicio > new Date().getTime()) {
            return {estado: 'Procesando', color: '#D9D9D9', colorLetras: '#131313'}
        }

        if (item.estado === 'Activo') {
            return {estado: 'Activo', color: theme.palette.primary.main, colorLetras: '#fff'}
        }

        if (item.estado === 'Duplicado') {
            return {estado: 'Duplicado', color: '#33DA00', colorLetras: '#131313'}
        }


        return {estado: item.estado, color: '#ffffff00', colorLetras: '#ffffff00'}

    }


    const obtenerReloj = (estado) => {

        switch (estado) {
            case 'Procesando':
                return <RelojProcesando fechaInicio={item.fechaInicio}/>
                break
            case 'Activo':
                return <RelojActivo fechaRendimientos={obtenerFechaRendimientos()}/>
                break
            default:
                return <Typography sx={{
                    fontSize: 12,
                    color: '#054073',
                    fontWeight: 400,
                    textAlign: 'center',
                    lineHeight: 1.1
                }}>Rendimientos <br/>
                    Completados
                </Typography>

        }

    }

    useEffect(() => {

        if (item.id) {
            obtenerRendimientosBonosContrato(item.id).then((dox) => {

                setRendimientosBonos(dox)
            })
        }

    }, [item]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#fff',
                borderRadius: 1,
                p: 2,
                color: '#011237',
                minHeight: 150
            }}
        >

            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',}}>
                        <Typography sx={{fontSize: 14, fontWeight: 400, color: '#054073'}}>ID Único</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -0.5}}>
                        <Typography
                            sx={{fontSize: 12, fontWeight: 400, color: '#054073'}}>{reducirHash({
                            hash: item.hash,
                            largo: 10
                        })}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Typography sx={{fontSize: 24, fontWeight: 600, color: theme.palette.primary.main}}>
                            {`${formatoMonedaTabla(item.valor, 2)} USD`}
                        </Typography>
                    </Grid>


                </Grid>
            </Grid>

            <Grid container size={{xs: 6, sm: 6, md: 6}}
                  sx={{justifyContent: 'flex-start', mr: sCell ? -2 : 0, ml: sCell ? 2 : 0}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid ref={refe} container size={{xs: 9, sm: 9, md: 9}}
                          sx={{justifyContent: 'center', mt: 2, color: '#000'}}>
                        {rendimientosBonos > 0 ?

                            <Dona_Limpia ancho={ancho} labels={labels}
                                         series={[rendimientosBonos ? rendimientosBonos : 0.1, (item.valor * 2) - (rendimientosBonos)]}
                                         marginTop={-10}
                                         defAncho={'40%'}
                                         colores={['#1F7DFE', '#e1e1e1']}/>

                            :

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}/>


                        }

                    </Grid>

                    <Grid container size={{xs: 3, sm: 3, md: 3}} sx={{justifyContent: 'flex-start', ml: -2}}>
                        <Typography sx={{
                            fontSize: 14,
                            color: '#011237',
                            fontWeight: 700
                        }}>{`${obtenerPorcentaje({total: item.valor, valor: rendimientosBonos})} %`}</Typography>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 10, md: 10}}
                          sx={{justifyContent: 'center', mt: 1, ml: sCell ? -2 : 0}}>
                        {obtenerReloj(obtenerEstado().estado)}
                    </Grid>


                </Grid>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -2}}>
                <Typography sx={{
                    color: obtenerEstado().colorLetras,
                    backgroundColor: obtenerEstado().color,
                    px: 2,
                    fontSize: 12,
                    borderRadius: 1,
                    pt: 0.1
                }}>{obtenerEstado().estado}</Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Contratos

const labels = ['Entregados', 'Por Entregar']

